import React from 'react';
import { Navigate } from 'react-router-dom';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import { COLORS, SPACING, TYPOGRAPHY, RADIUS } from '../design/tokens';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: COLORS.bg.base,
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <ArrowPathIcon
            style={{
              width: SPACING[32],
              height: SPACING[32],
              color: COLORS.text.tertiary,
              animation: 'spin 1s linear infinite',
              margin: '0 auto',
            }}
          />
          <p
            style={{
              marginTop: SPACING[8],
              fontSize: TYPOGRAPHY.body.sizes.small,
              color: COLORS.text.secondary,
            }}
          >
            Loading...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
